import React, { useState, useEffect, useRef, createContext } from "react";

const BudgetContext = createContext();

export const BudgetConsumer = BudgetContext.Consumer;

const BudgetProvider = (props) => {
  const [budget, setBudget] = useState([]);

  return (
    <BudgetContext.Provider
      value={{
        budget,
        setBudget,
      }}
    >
      {props.children}
    </BudgetContext.Provider>
  );
};

export default BudgetContext;

export { BudgetProvider, BudgetContext };
